import Icon from '@material-ui/icons/Bookmark';
import React from 'react';
import { CreateButton } from '../../../buttons';
import { EditDialog, Filter, NestedResourceList, ResourceList, ResourceShow, Tab, TabbedShowLayout } from '../../../controllers';
import { BooleanField, EnumField, JavaScriptField, KidScriptField, NumberField, TextField } from '../../../fields';
import { BooleanInput, EnumInput, JavaScriptInput, NestedReferenceInput, SearchInput, TextInput } from '../../../inputs';
import library_engine_method_modules from './library_engine_method_modules';
import library_engine_method_parameters from './library_engine_method_parameters';

export default {
  Icon,
  dialogs: {
    edit: props => (
      <EditDialog
        {...props}
      >
        <TextField
          source="name"
        />
        <BooleanField
          source="internal"
        />
        <TextInput
          source="description"
        />
        <JavaScriptInput
          source="javascript"
        />
        <EnumInput
          source="return_type"
          versionedAttribute
        />
        <NestedReferenceInput
          optionText="name"
          resourcePath={`/library_engines/${props.parentResource.parentResource.id}`}
          source="library_engine_configuration_option_id"
        />
        <TextInput
          source="engine_configuration_option_value"
        />
      </EditDialog>
    ),
    create: props => (
      <CreateButton
        fixedValue={{ library_engine_id: props.parentResource.id }}
        {...props}
      >
        <TextInput
          source="name"
        />
        <BooleanInput
          source="internal"
        />
        <TextInput
          source="description"
        />
        <JavaScriptInput
          source="javascript"
        />
        <EnumInput
          source="return_type"
          versionedAttribute
        />
      </CreateButton>
    ),
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <TextField
          source="name"
        />
        <TextField
          source="description"
        />
        <BooleanField
          source="internal"
        />
        <EnumField
          source="return_type"
          versionedAttribute
        />
      </ResourceList>
    ),
    show: props => (
      <ResourceShow
        {...props}
      >
        <TabbedShowLayout>

          <Tab
            label="Preview"
          >
            <JavaScriptField
              source="preview"
            />
          </Tab>

          <Tab
            label="General"
          >
            <TextField
              source="name"
            />
            <TextField
              source="description"
            />
            <BooleanField
              source="internal"
            />
            <KidScriptField
              source="kidscript"
            />
            <JavaScriptField
              source="javascript"
            />
            <EnumField
              source="return_type"
              versionedAttribute
            />
          </Tab>

          <Tab
            label="Parameters"
          >
            <NestedResourceList
              reference="library_engine_method_parameters"
            >
              <NumberField
                source="position"
              />
              <TextField
                source="name"
              />
              <EnumField
                source="class_name"
                versionedAttribute
              />
            </NestedResourceList>
          </Tab>

          <Tab
            label="Modules"
          >
            <NestedResourceList
              reference="library_engine_method_modules"
            >
              <TextField
                source="name"
              />
            </NestedResourceList>
          </Tab>

        </TabbedShowLayout>
      </ResourceShow>
    ),
  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <SearchInput
          label="Search"
          source="q"
        />
        <BooleanInput
          label="Deleted"
          source="deleted"
        />
      </Filter>
    ),
  },
  resources: {
    library_engine_method_modules,
    library_engine_method_parameters,
  },
};
